import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessageStackService {
  messageStack! :any;

  constructor() { }
}
